import React from "react";
import { motion } from "framer-motion";
import bunnyImg from "../assets/logo_text.png"; // ← your image with tools already in it
import brand from "../assets/brand1.png";

const WhoAreWe = () => {
  return (
    <section
      className="bg-white py-20 px-4 sm:px-6 lg:px-16 overflow-hidden"
      style={{ fontFamily: "'Poppins', sans-serif" }}
    >
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">

          {/* ── LEFT: Text ── */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, ease: "easeOut" }}
            className="flex flex-col items-center lg:items-center text-center lg:text-left "
          >
            {/* X icon */}
            <motion.div
              initial={{ opacity: 0, scale: 0 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              className="mb-5 select-none"
            >
              <img
                src={brand}
                alt="Brand icon"
                className=" object-contain"
                style={{ width: 24 }}
              />
            </motion.div>

            {/* Heading */}
            <motion.h2
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.25, duration: 0.5 }}
              className="text-3xl md:text-2xl text-gray-900 mb-4 font-medium text-center"
              style={{ fontFamily: "'Space Grotesk', sans-serif" }}
            >
              Designs with perfect syntax
            </motion.h2>

            {/* Body */}
            <motion.p
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.35, duration: 0.5 }}
              className="text-gray-500 leading-relaxed mb-10 max-w-lg text-sm md:text-base text-center lg:text-left"
            >
              SINTX is a branding and creative studio helping businesses build distinctive identities and bring them to life. From brand identity and social media design to content creation, packaging, and website design, we create cohesive brand experiences that connect with people and make businesses memorable.
            </motion.p>

            {/* Know More — gradient border button */}
            <motion.button
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.45, duration: 0.5 }}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              style={{
                padding: "10px 36px",
                borderRadius: "100px",
                border: "1.5px solid transparent",
                background:
                  "linear-gradient(#fff, #fff) padding-box, linear-gradient(135deg, #129ADC, #E154AA) border-box",
                fontFamily: "'Poppins', sans-serif",
                fontSize: "14px",
                fontWeight: 600,
                cursor: "pointer",
              }}
            >
              <span
                style={{
                  background: "linear-gradient(135deg, #129ADC, #E154AA)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  backgroundClip: "text",
                  display: "inline-block",
                }}
                  onClick={() => (window.location.href = "/about")}
              >
                Know More
              </span>
            </motion.button>
          </motion.div>

          {/* ── RIGHT: Image only — no extra icons ── */}
          <motion.div
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            className="relative flex items-center justify-center"
            style={{ height: 480 }}
          >
            {/* Gray circle bg */}
            <div
              style={{
                position: "absolute",
                width: 400,
                height: 400,
                borderRadius: "50%",
                background: "#efefef",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
              }}
            />

            {/* Image with tools already inside it — gentle float */}
            <motion.img
              src={bunnyImg}
              alt="Bunny character"
              animate={{ y: [0, -14, 0] }}
              transition={{
                duration: 4,
                repeat: Infinity,
                ease: "easeInOut",
              }}
              style={{
                position: "relative",
                zIndex: 2,
                width: "100%",
                maxWidth: 420,
                height: "auto",
                objectFit: "contain",
                filter: "drop-shadow(0 24px 40px rgba(0,0,0,0.10))",
              }}
            />
          </motion.div>

        </div>
      </div>
    </section>
  );
};

export default WhoAreWe;